<template>
  <div class="container-view">
    <Breadcrumbs />
    <div class="row col-12 container-titles" style="display: flex">
      <div class="header-title col-10">Vertical {{ dataVertical.name }}</div>
      <div class="col-2" style="padding-top: 24px; align-items: flex-end">
        <q-btn
          data-cy="save-vertical"
          style="width: 100%; margin-left: 0 !important"
          color="primary"
          label="Guardar"
          icon="save"
          @click="isNew ? emitNew() : emitgeneralSave()"
          :loading="isLoadingButton"
        />
      </div>
    </div>
    <div class="row col-12 full-height">
      <div class="col-8">
        <Informacion
          :dataVertical="dataVertical"
          :isNew="isNew"
        />
      </div>
      <div class="col-4 right-container">
        <MultiSelect
          :labelBox="{
            title: 'Temáticas',
            subtitle: (!isNew && isNew !== '' ? dataVertical.name : 'El vertical') + ' pertenece a las siguientes temáticas',
            select: 'Añadir temática'
          }"
          labelDataCy="tematica-select"
          endPoint="Vertical"
          :dataObj="dataVertical"
          relationShip="tematica-relationship"
          :arraySelected="arraySelectedTematicas"
          :arrayAll="arrayTematicas"
          :eventName="events.saveTematica"
        />
      </div>
    </div>
    <div class="row col-12">
      <div class="col-12" id="group-container">
        <Ambitos
          :dataVertical="dataVertical"
          :arrayAmbitos="arrayAmbito"
          :isNew="isNew"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Message from '@/components/shared/mixins/Message.js';
import Validation from '@/components/shared/mixins/Validation.js';
import Loading from '@/components/shared/mixins/Loading.js';
import Informacion from '../components/Informacion.vue';
import MultiSelect from '@/shared/generic-multi-select/MultiSelect.vue';
import Ambitos from '../components/Ambitos.vue';
import Resources from '@/components/shared/mixins/Resources.js';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';

export default {
  components: {
    Informacion,
    MultiSelect,
    Ambitos,
    Breadcrumbs
  },
  mixins: [Message, Validation, Loading, Resources],
  data: function () {
    return {
      arrayTematicas: [],
      arraySelectedTematicas: [],
      arrayAmbito: [],
      dataVertical: {},
      isLoading: false,
      isNew: false,
      isLoadingButton: false,
      checkSave: {
        isInfoSave: null,
        isGrupoSave: null,
        isAmbitoSave: null,
        existError: false
      },
      events: {
        saveVertical: 'APLICACION_ACTUALIZAR_INFORMACION',
        saveLogotipo: 'EJECUCION_GUARDAR_LOGOTIPO',
        saveVideo: 'EJECUCION_GUARDAR_VIDEO',
        saveTematica: 'EJECUCION_GUARDAR_GRUPOS',
        saveAmbitos: 'EJECUCION_GUARDAR_AMBITOS'
      }
    };
  },
  methods: {
    emitNew () {
      // Reset variables
      this.resetSaved();

      this.$eventHub.$emit(this.events.saveVertical, {
        callback: (x) => {
          this.dataVertical.id = x.data.id;
          this.checkSave.isInfoSave = x.status;

          this.$eventHub.$emit(this.events.saveTematica, {
            callback: (x) => {
              this.checkSave.isGrupoSave = x.status;
              // this.checkSaved();
              this.$eventHub.$emit(this.events.saveAmbitos, {
                callback: (x) => {
                  this.checkSave.isAmbitoSave = x.status;
                  this.checkSaved();
                  this.isNew = false;

                  this.$eventHub.$emit(this.events.saveLogotipo, {
                    callback: (x) => {}, rejected: (x) => {}
                  });

                  this.$eventHub.$emit(this.events.saveVideo, {
                    callback: (x) => {
                      // Change Page
                      this.$router.push({
                        name: 'form_edit_vertical',
                        params: { idVertical: this.dataVertical.id }
                      });
                    },
                    rejected: (x) => {}
                  });
                }
              });
            }
          });
        },
        rejected: (x) => {
          this.checkSave.isInfoSave = x.status;
          this.checkSaved();
        }
      });
    },
    async emitgeneralSave () {
      // Reset variables
      this.resetSaved();

      if (!this.isNew) {
        await this.$eventHub.$emit(this.events.saveVertical, {
          callback: (x) => {
            this.checkSave.isInfoSave = x.status;
            this.checkSaved();
            this.$eventHub.$emit(this.events.saveTematica, {
              callback: (x) => {
                this.checkSave.isGrupoSave = x.status;
                this.checkSaved();
                this.$eventHub.$emit(this.events.saveAmbitos, {
                  callback: (x) => {
                    this.checkSave.isAmbitoSave = x.status;
                    this.checkSaved();

                    this.$eventHub.$emit(this.events.saveVideo, {
                      callback: (x) => {}, rejected: (x) => {}
                    });

                    this.$eventHub.$emit(this.events.saveLogotipo, {
                      callback: (x) => {}, rejected: (x) => {}
                    });
                  }
                });
              }
            });
          },
          rejected: (x) => {
            this.checkSave.isInfoSave = x.status;
            this.checkSaved();
          }
        });
      }
    },
    resetSaved () {
      this.isLoadingButton = true;
      this.checkSave.existError = false;
      this.checkSave.isInfoSave = null;
      this.checkSave.isGrupoSave = null;
      this.checkSave.isAmbitoSave = null;
    },
    checkSaved () {
      if (this.checkSave.isInfoSave && this.checkSave.isGrupoSave && this.checkSave.isAmbitoSave) {
        this.showMessage('Datos guardados con éxito.');
        // Stop Loading Button
        this.isLoadingButton = false;
      } else if (
        (this.checkSave.isInfoSave === false || this.checkSave.isGrupoSave === false || this.checkSave.isAmbitoSave === false) &&
        this.checkSave.existError === false
      ) {
        this.checkSave.existError = true;
        this.showError('No se han podido guardar los datos.');
        // Stop Loading Button
        this.isLoadingButton = false;
      }
    },
    async getInfoVertical (verticalId = null) {
      let idVertical = verticalId;

      this.showLoading();

      if (!idVertical) {
        this.showError('No es un vertical válido.');
        this.$router.push({ name: 'verticales' });
      }

      let request = {
        controller: '/Vertical/' + idVertical
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then(async (response) => {
          let data = response.data;
          data.id = idVertical;
          data.resources = await this.getResources('Vertical', idVertical);
          this.dataVertical = data;
          this.arraySelectedTematicas = data.tematicas;
          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });
    },
    async getTematicas () {
      this.showLoading();
      let request = {
        controller: '/Tematica'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.arrayTematicas = response.data;
          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });
    },
    async _getAmbitos () {
      this.showLoading();

      let request = {
        controller: '/Ambito'
      };

      await this.$store
        .dispatch('PF/getSuit', request)
        .then((response) => {
          this.arrayAmbito = response.data;
          this.hideLoading();
        })
        .catch((err) => {
          this.showError(err.message);
          this.hideLoading();
        });
    }
  },
  async created () {
    if (this.$route.params.idVertical) {
      await this.getInfoVertical(this.$route.params.idVertical);
    } else {
      this.isNew = true;
    }

    await this.getTematicas();
    await this._getAmbitos();
  }
};
</script>
<style lang="scss" scoped>

.right-container {
  padding-left: 32px;
}

#group-container {
  padding-top: 32px;
}
</style>
